import src from "IMAGE";
export default { src, width: 307, height: 337, blurWidth: 7, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAS0lEQVR42p2LQQ6AIAwE+f9vsRBAC2MjIVSPbjKnmQ2sdYVWISc4IkgkbNnhbFAyJLFInBwm9bK3BbU8ODnmW3VGxpYrcLzlZ//lDW9F3iFLruHwAAAAAElFTkSuQmCC"};
